import React from 'react';
import TaskStatus from './../../../../services/TaskStatus';

const classMap = new Map();
classMap.set(TaskStatus.QUEUED, 'info');
classMap.set(TaskStatus.ERROR, 'danger');
classMap.set(TaskStatus.COMPLETE, 'success');
classMap.set(TaskStatus.RUNNING, 'warning');

const nameMap = new Map();
nameMap.set(TaskStatus.QUEUED, 'I kø');
nameMap.set(TaskStatus.ERROR, 'Feil');
nameMap.set(TaskStatus.COMPLETE, 'Ferdig');
nameMap.set(TaskStatus.RUNNING, 'Kjører');

export default (props) => {
  return (
    <span className={`label label-${classMap.get(props.status)}`}>{nameMap.get(props.status)}</span>
  );
};
